var _defs, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBaseball(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Baseball_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Baseball_svg__a",
    d: "M22.357 16.163a1.3 1.3 0 11-1.844 0 1.3 1.3 0 011.844 0M9.818 16.409l-3.605 3.605.118.118a1.473 1.473 0 010 2.083 1.473 1.473 0 01-2.083 0l-2.554-2.554a1.473 1.473 0 010-2.083 1.473 1.473 0 012.083 0l.118.118L7.5 14.091l.911-1.348a71.821 71.821 0 018.728-10.577 3.119 3.119 0 014.4.209 3.119 3.119 0 01.209 4.4 71.89 71.89 0 01-10.582 8.722l-1.347.911zM9.059 16.06l-1.272-1.272"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fillRule: "evenodd",
    fill: "none"
  })));
}

export default SvgBaseball;


//////////////////
// WEBPACK FOOTER
// ./src/icons/Baseball.svg
// module id = 860
// module chunks = 101